import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@/i18n/client';
import { useHomePageStore } from '@/store/useHomepageStore';

import styles from './index.less';

interface IProps {
  step: number;
  className?: string;
}

const CreateHeader = (props: IProps) => {
  const { step, className } = props;

  const { t } = useTranslation();

  const [originProgressStepWidth, setOriginProgressStepWidth] = useState<string | undefined>(
    undefined
  );

  const homePage = useHomePageStore((state) => state.homePage);

  useEffect(() => {
    if (step !== 2) return;

    setOriginProgressStepWidth(homePage?.cover ? '95%' : '50%');
  }, [homePage?.cover, step]);

  const progressStepWidth = useMemo(() => {
    switch (step) {
      case 1:
        return '5%';
      case 2:
        return '50%';
      default:
        return '15%';
    }
  }, [step]);

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={styles.progressBar}
        style={
          {
            '--progress-step-width': originProgressStepWidth || progressStepWidth
          } as React.CSSProperties
        }
      />
      <div className={styles.title}>{`${t('onboarding.create.createMySecondMe')} ${step}/2`}</div>
    </div>
  );
};

export default CreateHeader;
